<template>
	<div>
		<CCard>
			<CCardHeader> Manifeste de sûreté aérienne </CCardHeader>
			<CCardBody v-show="loadingSafetyManifest"><Loading /></CCardBody>
			<CCardBody v-show="!loadingSafetyManifest">
				<CRow>
					<CCol md="3">
						<CFormGroup class="form-group">
							<template #label>
								<label>Concept</label>
							</template>
							<template #input>
								<GTreeView
									v-on:update:selected="data => (concept = data)"
									:local-data="concepts"
									:multiple="false" />
							</template>
						</CFormGroup>
					</CCol>
					<CCol md="3">
						<vc-date-picker
							v-model="dateSafetyManifest"
							mode="date"
							timezone="UTC"
							:model-config="datepickerConfig">
							<template v-slot="{ inputValue, inputEvents }">
								<CInput
									label="Date du vol"
									type="text"
									name="flightDate"
									:value="inputValue"
									v-on="inputEvents" />
							</template>
						</vc-date-picker>
					</CCol>
					<CCol md="3">
						<CFormGroup class="form-group">
							<template #label>
								<label>Vol</label>
							</template>
							<template #input>
								<GTreeView
									v-on:update:selected="data => (flight = data)"
									:local-data="flights"
									id-prop="id"
									label-prop="LTA"
									:multiple="false" />
							</template>
						</CFormGroup>
					</CCol>
					<CCol md="3">
						<CFormGroup class="form-group">
							<template #label>
								<label>Palette</label>
							</template>
							<template #input>
								<GTreeView
									v-on:update:selected="data => (pallet = data)"
									:local-data="pallets"
									id-prop="id"
									label-prop="reference"
									:multiple="false" />
							</template>
						</CFormGroup>
					</CCol>
				</CRow>

				<CRow>
					<CCol md="4">
						<CButton color="primary" class="d-block mt-2" @click="onSubmitSafetyManifest"
							>Télécharger</CButton
						>
					</CCol>
				</CRow>
			</CCardBody>
		</CCard>
	</div>
</template>

<script>
	import GTreeView from '../../../../components/ghostlexly-components/GTreeView';
	import Loading from '../../../../components/loading';
	import GSelect from '@/components/ghostlexly-components/GInputs/GSelect';
	export default {
		components: {
			GSelect,
			Loading,
			GTreeView,
		},

		data() {
			return {
				loadingSafetyManifest: false,
				concepts: [
					{ '@id': 'all', name: 'Tous' },
					{ '@id': 'order.colipays', name: 'Colipays' },
					{ '@id': 'order.colikado', name: 'Colikado' },
					{ '@id': 'order.aupaysdesfleurs', name: 'Au pays des fleurs' },
				],
				concept: null,
				datepickerConfig: {
					type: 'string',
					mask: 'YYYY-MM-DD',
				},
				dateSafetyManifest: this.$moment().format('YYYY-MM-DD'),
				flights: [],
				flight: null,
				pallets: [],
				pallet: null,
			};
		},

		watch: {
			dateSafetyManifest: {
				immediate: true,
				handler(val) {
					this.loadingSafetyManifest = true;
					this.flight = null;

					this.$axios.get(`/api/flights?departureTime=${val}`).then(res => {
						this.flights = res.data['hydra:member'];
						this.loadingSafetyManifest = false;
					});
				},
			},

			flight: {
				immediate: true,
				handler(val) {
					this.pallet = null;

					if (this.flight) {
						this.$axios.get(`/api/pallets?flight=${this.flight}`).then(res => {
							this.pallets = res.data['hydra:member'];
						});
					}
				},
			},
		},

		methods: {
			onSubmitSafetyManifest() {
				if (
					!this.flight ||
					!this.pallet ||
					!this.concept ||
					this.concept === null ||
					this.flight === null ||
					this.pallet === null
				) {
					this.$toast.error('Veuillez renseigner tous les champs.');
					return false;
				}

				this.loadingSafetyManifest = true;

				// download the file
				this.$axios
					.get(
						`/api/flights/manifest/safety/${this.flight
							.toString()
							.split('/')
							.pop()}/${this.concept.toString().split('/').pop()}/${this.pallet
							.toString()
							.split('/')
							.pop()}`,
						{ responseType: 'blob' }
					)
					.then(res => {
						if (res.status === 200 || res.status === 201) {
							let filename = res.headers['content-disposition'];
							filename = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/.exec(filename);
							if (filename != null && filename[1]) {
								filename = filename[1].replace(/['"]/g, '');
							} else {
								filename = 'file.pdf';
							}

							const url = window.URL.createObjectURL(new Blob([res.data]));
							const link = document.createElement('a');
							link.href = url;
							link.setAttribute('download', filename); //or any other extension
							document.body.appendChild(link);
							link.click();

							this.loadingSafetyManifest = false;
						}
					})
					.catch(err => {
						new Blob([err.response.data]).text().then(data => {
							data = JSON.parse(data);
							this.$toast.error(data['hydra:description']);
							this.loadingSafetyManifest = false;
						});
					});
			},
		},
	};
</script>
